export function useTranslations(_ns?: string) {
  return (key: string, _values?: Record<string, string | number>) => key;
}
